import { render, staticRenderFns } from "./WorksSearchForm.vue?vue&type=template&id=6b526918&"
import script from "./WorksSearchForm.vue?vue&type=script&lang=js&"
export * from "./WorksSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports